import { Component, computed, effect, input, signal } from '@angular/core';

@Component({
    selector: 'file-viewer',
    template: `
        @if (fileUrl() && fileType() === 'application/pdf') {
          <pdf-viewer [fileUrl]="fileUrl()"></pdf-viewer>
        }
        @if (text()) {
          <pre class="preview-window">{{text()}}</pre>
        }
        @if (isImage()) {
          <img [attr.src]="fileUrl()" class="img-responsive preview-window-image" alt="Image File Missing" />
        }
        `,
    styles: [`
        .preview-window {
            white-space: pre-wrap;
            word-break: break-word;
        }
        .preview-window-image {
            margin: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `],
    standalone: false
})
export class FileViewerComponent {
    constructor() {
        effect(() => {
            const currentFile = this.file();
            if (currentFile) {
                this._loadFile();
            }
        });
    }

    file = input<File | null>(null);

    fileUrl = signal<string>('');
    text = signal<string | ArrayBuffer>('');
    fileType = computed(() => this.file()?.type ?? '');
    isImage = computed(() => this.fileType().startsWith('image'));

    private _loadFile(): void {
        if (this.fileType() === 'text/plain') {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                this.text.set(fileReader.result);
            };

            fileReader.readAsText(this.file());
        } else if (this.isImage()) {
            const reader = new FileReader();
            reader.readAsDataURL(this.file());
            reader.onload = () => {
                this.fileUrl.set(reader.result as string);
            };
        } else {
            const blob = new Blob([this.file()], { type: this.fileType() });
            this.fileUrl.set(URL.createObjectURL(blob));
        }
    }
}
